<template>
  <div class="container">
    <div v-if = "CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN.length>0" class="alert-container mb-2" >
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{CONSTANTS.MESSAGE_FOR_SUPPLIER_CENTRAL_DOWN}}</strong></div>
              </div>
            </div>
    <alert-message v-if="errorMessage"></alert-message>
    <loading-spinner v-if="isLoading"></loading-spinner>
    <div class="mt-4" v-show="!isLoading">
      <div class="main-title mb-2 align-with-table">{{CONSTANTS.PURCHASE_ORDERS_COMPONENT_TITLE_HEADER}}</div>
      <div class="mb-2 pb-2 align-with-table" v-if="viewingAPUserDataFor">Showing results for <span class="font-weight-bold">{{viewingAPUserDataFor}}</span></div>
      <div v-if="this.viewingAPUserDataFor" class="align-with-table mb-2">
        <a class="solution-link" @click="resetNamesAndPOInvoices">View your invoices/purchase orders </a>
      </div>

      <div class="row d-block px-4 py-2">
        <div class="font-italic loading-filters"><a @click="showPoFilterFAQModal('purchase order')" class="solution-link">Learn more</a> about the data that you are eligible to view.</div>
      </div>

      <purchase-order-filters
        :isRolesFilterChanged="isRolesFilterChanged"
        @onPurchaseOrderRolesFilterChanged="onPurchaseOrderRolesFilterChanged($event)"
        @onSetVgtSortedArraySum="onSetVgtSortedArraySum($event)"
        @onFilteredPOListUpdated="onFilteredPOListUpdated($event)"
        @onUpdateTotalValueWithSortedData="updateTotalValueWithSortedData" />
      <div class="row justify-content-md-end m-3" v-if="parseFloat(grandTotalValue) > 0">
        Grand total: <strong class="ml-1">USD {{grandTotalValue}}</strong>
      </div>
      <div class="row no-gutters mt-3" v-if="!isLoading">
        <vue-good-table
            :columns="columns"
            :rows="purchaseOrdersList"
            class="table-word-wrap po-table"
            :pagination-options="poPaginationConfig"
            :sort-options="poSortConfig"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-per-page-change="onPerPageChange"
            ref="purchaseOrderTable"
            :class="isLoading ? 'd-none':''"
            :key="componentKey"
        >
          <template slot="table-column" slot-scope="props">
          <span v-if="props.column.label === 'Purchase order date'" @click="userSortClicked">
            <header-with-tooltip :tooltipText="FORM_LABELS.TOOLTIPS.dateTooltip"> {{props.column.label}} </header-with-tooltip>
          </span>
            <span v-else @click="userSortClicked(props.column.label)">{{props.column.label}}</span>
          </template>

          <div slot="emptystate">{{ noRecordsMessage }}</div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'poNumber'">
              <span class="solution-link" @click="onPurchaseOrderClicked(props.row)">{{props.row.poNumber}}</span>
            </span>
            <span v-else-if="props.column.field === 'requestedByFullName'">
              <div class="content row-content" v-if="isValidString(props.row.requestedBy)">
                        <div>
                            <user-full-name :user-detail="getUserDetail(props.row.requestedBy)"></user-full-name>
                        </div>
              </div>
              <div v-else>N/A</div>
            </span>
          </template>
          <div slot="table-actions-bottom" class="totals-container hide-field-xs" style="position: relative;" v-show="isValidTotalValue">
            <total-for-current-view
                :columns="columns"
                :isSortedArraySum="vgtSortedData.isSortedArraySum"
                :totalValue="totalValue"
                :sortedArraySum="vgtSortedData.sortedArraySum"
            />
          </div>
        </vue-good-table>

      </div>

      <div class="row d-block pl-4 pt-4">
       <div class="font-italic" v-html="FORM_LABELS.PO_18_MONTHS_DESCRIPTION" />
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import CONSTANTS from "@/store/constants";
import {mapGetters, mapActions,mapMutations} from "vuex"
import AlertMessage from "../AlertMessage";
import LoadingSpinner from "../LoadingSpinner";
import filters from "@/filters/filter";
import TotalForCurrentView from "@/components/InvoiceAndPurchaseOrders/TotalForCurrentView";
import UserFullName from "@/components/UserFullName";
import InvoicesPOFiltersMixin from "@/mixins/InvoicesPOFiltersMixin";
import PurchaseOrderFilters from "@/components/InvoiceAndPurchaseOrders/PurchaseOrderFilters";
import InvoicesAndPOMixin from "@/mixins/InvoicesAndPOMixin";


import VGT_COLUMNS from "@/store/vgtColumns";

export default {
  name: "PurchaseOrders",
  components: { LoadingSpinner, AlertMessage, VueGoodTable, TotalForCurrentView, UserFullName, PurchaseOrderFilters },
  mixins: [InvoicesPOFiltersMixin, InvoicesAndPOMixin],
  filters,
  data() {
    return {
      filteredList:null,
      PO_NUMBER_FIELD: "poNumber",
      noRecordsMessage:"You don't have any purchase orders to display.",
      //vgtSortedArray is a sorted array we fetch from vue-good-table component, to display total sum of current view POs.
      vgtSortedData: {
        vgtSortedArray: [],
        isSortedArraySum: false,
        sortedArraySum: 0
      },
      isRolesFilterChanged: false,
      columns: VGT_COLUMNS.PURCHASE_ORDER_TABLE_COLUMNS
    }
  },
  computed: {
    ...mapGetters(["purchaseOrdersFormattedList","currentUser","errorMessage","isLoading", "poTableUserPreferences","viewingAPUserDataFor","isAPAdmin", "userData","rolesToNamesMap","apUserId","isNamesFilterLoading","rolesObj","poFiltersList"]),
    grandTotalValue() {
      let grandTotalValue = 0
      if(this.purchaseOrdersFormattedList && this.purchaseOrdersFormattedList.length > 0) {
        this.purchaseOrdersFormattedList.forEach(po => {
          grandTotalValue += this.getGrandTotal(po)
        })
      }
      return grandTotalValue.toLocaleString(CONSTANTS.EN_US_LOCALE)
    },
    directReportsExist() {
      return this.rolesToNamesMap && this.rolesToNamesMap.directReports && this.rolesToNamesMap.directReports.length > 0
    },
    isValidTotalValue() {
      return (Number(parseFloat(this.totalValue.toString().replace(/,/g, ''))) || Number(parseFloat(this.vgtSortedData.sortedArraySum.toString().replace(/,/g, '')))) > 0
    },
    totalValue() {
      let sum = 0
      this.paginationEnabled ? sum = this.getTotalForCurrentView(this.currentPurchaseOrderTableData()) : sum = this.getTotalForCurrentView(this.purchaseOrdersList)
      return sum
    },
    poPaginationConfig() {
      return { enabled: this.paginationEnabled, setCurrentPage: this.poTableUserPreferences.pagination.currentPage, perPage: this.poTableUserPreferences.pagination.currentPerPage }
    },
    poSortConfig() {
      return { enabled: true, initialSortBy: { field: this.poTableUserPreferences.sort.field, type: this.poTableUserPreferences.sort.type }}
    },
    paginationEnabled() {
      return this.purchaseOrdersList && this.purchaseOrdersList.length > 0 ?  this.purchaseOrdersList.length > CONSTANTS.PAGINATION_THRESHOLD : false
    },

    purchaseOrdersList() {
      if(this.filteredList && this.filteredList.length > 0 || this.filtersSelected) {
        return this.filteredList
      } else {
        return []
      }
    }
  },
  methods: {
    ...mapMutations(["setPurchaseOrdersFormattedList","setPOTableUserPreferences","setPrevRoute","setViewingAPUserDataFor","setRolesToNamesMap"]),
    ...mapActions(["fetchPurchaseOrders"]),
    currentPurchaseOrderTableData(){
      let currentViewArray = []
      let poObj = this.$refs.purchaseOrderTable
      if (poObj &&  poObj.$data && poObj && poObj.$data && poObj.$data.filteredRows.length > 0 && poObj.$data.filteredRows[0].children && poObj.$data.filteredRows[0].children.length > 0){
        currentViewArray = this.getCurrentPageRecords(poObj.$data.filteredRows[0].children)
      }
      return currentViewArray
    },
    getCurrentPageRecords(arrayObj) {
      let pageNumber = parseInt(this.poTableUserPreferences.pagination.currentPage, 10)
      let currentPerPage = parseInt(this.poTableUserPreferences.pagination.currentPerPage, 10)

      let currentViewArray = arrayObj && arrayObj.length > 0 ?
          (arrayObj.slice((pageNumber - 1) * currentPerPage, pageNumber * currentPerPage)) : []

      return currentViewArray
    },
    getTotalForCurrentView(parsedArray) {
      let total = 0
      if(parsedArray && parsedArray.length > 0) {
        parsedArray.forEach(po => {
          let number = po.netValueInUsd.replace(/,/g,'')
          number = parseFloat(number, 10)
          total += number
        })
      }
      return total.toLocaleString(CONSTANTS.EN_US_LOCALE)
    },

    /*
    * Current view can be either requested by or created by current user -- but it can also be records which are direct reports
    * or cost center or costCenterFBP. Below method is called in an iteration in computed to capture netValueInUSD for all the records currently
    * being displayed to the user.
    *  */
    getGrandTotal(po) {
      let userId = this.viewingAPUserDataFor ? this.apUserId : this.currentUser.userName
      if(po.createdBy === userId || po.requestedBy === userId) {
        return this.poNetValueInUsd(po)
      } else if(po.poAdditionalData && po.poAdditionalData.length > 0 && this.userIsCostCenterOrFBPOwner(po, userId)) {
          return this.poNetValueInUsd(po)
      } else if(this.rolesToNamesMap.directReports && this.rolesToNamesMap.directReports.length > 0 && this.poRequestedByDirectReport(po)) {
            return this.poNetValueInUsd(po)
      }
      return 0
    },
    poRequestedByDirectReport(po) {
      return this.rolesToNamesMap.directReports.indexOf(po.requestedByFullName) !== -1
    },
    userIsCostCenterOrFBPOwner(po, userId) {
      return po
          && po.poAdditionalData
          && po.poAdditionalData.length > 0
          && (po.poAdditionalData.some((additionalData) => additionalData.costCenterOwner === userId)
          || po.poAdditionalData.some((additionalData) => additionalData.costCenterFbp === userId))
    },
    poNetValueInUsd(po) {
      if (po && po.netValueInUsd) {
        let netValue = po.netValueInUsd.replace(/,/g, '')
        netValue = parseFloat(netValue, 10)
        return netValue
      }
    },

    userSortClicked(label) {
      //Sorting is not supported on Requested by column
      //'clear filters' option should not appear if user clicks on LABEL 'Requested by'.
      if(label !== 'Requested by') {
        this.poTableUserPreferences.userClickedSort = true
        this.poTableUserPreferences.showClearFilters = true
        this.setPOTableUserPreferences(this.poTableUserPreferences)
        this.updateTotalValueWithSortedData()
      }
    },
    onPageChange(params) {
      this.poTableUserPreferences.pagination.currentPage = params.currentPage
      this.poTableUserPreferences.pagination.currentPerPage = params.currentPerPage
      this.poTableUserPreferences.showClearFilters = true
      this.setPOTableUserPreferences(this.poTableUserPreferences)
      this.updateTotalValueWithSortedData()
    },

    updateTotalValueWithSortedData() {
      setTimeout(() => {
          this.vgtSortedData.vgtSortedArray = this.currentPurchaseOrderTableData()
          this.vgtSortedData.isSortedArraySum = true
          this.vgtSortedData.sortedArraySum = this.getTotalForCurrentView(this.vgtSortedData.vgtSortedArray)
      }, 300)
    },
    /*
    onSortChange method:
     vue-good-table emits onSortChange on route changes, so when we open modal, this method is autoInvoked
     the way we detect if user actually hit the sort buttons is via the userSortClicked method, and we persist it in store.
     If user did not click sort, user did not hit sort method and so we can pick last page from store
     If user manually sorted we reset current page in below method to 1 based on vgt functionality.
     */
    onSortChange(params) {
      this.poTableUserPreferences.sort.field = params[0].field
      this.poTableUserPreferences.sort.type = params[0].type

      if(this.poTableUserPreferences.userClickedSort) {
        this.poTableUserPreferences.pagination.currentPage = 1
        this.poTableUserPreferences.showClearFilters = true
      }
      this.poTableUserPreferences.userClickedSort = false
      this.setPOTableUserPreferences(this.poTableUserPreferences)
    },
    onPerPageChange(params) {
      this.vgtSortedData.isSortedArraySum = false

      this.poTableUserPreferences.pagination.currentPage = params.currentPage
      this.poTableUserPreferences.pagination.currentPerPage = params.currentPerPage
      this.poTableUserPreferences.showClearFilters = true
      this.currentPage = params.currentPage
      this.setPOTableUserPreferences(this.poTableUserPreferences)
    },
    setPreviousRoute() {
      if(this.$route.meta.tab === CONSTANTS.PURCHASE_ORDERS_TABLE_ROUTE) {
        this.setPrevRoute(CONSTANTS.PURCHASE_ORDERS_ROUTE)
      }
    },
    onPurchaseOrderClicked(po){
      this.setPreviousRoute()
      if(po && po.row)
        po= po.row
      this.$router.push({ name: 'Filtered POs', params: {key: this.PO_NUMBER_FIELD, value: po.poNumber }})
    },
    getUserDetail(userId) {
      return this.userData(userId)
    },
    async resetNamesAndPOInvoices() {
      await this.clickToViewYourInvoicesPO()
      await this.getAllNamesForFilter()
    },
    async getPurchaseOrders() {
      if(!this.purchaseOrdersFormattedList || this.purchaseOrdersFormattedList.length===0) {
        await this.fetchPurchaseOrders();
        await this.getAllNamesForFilter()
      }
      if(this.poTableUserPreferences && this.poTableUserPreferences.pagination.currentPage > 1) {
        await this.waitForPaginationRender()
      }
    },
    clearPOFilters() {
      if(this.$refs && this.$refs.purchaseOrderFilters) {
        this.$refs.purchaseOrderFilters.clearFilters()
      }
    },
    onPurchaseOrderRolesFilterChanged(event) {
      this.isRolesFilterChanged = event
    },
    onSetVgtSortedArraySum(event) {
      this.vgtSortedData.isSortedArraySum = event
    },
    onFilteredPOListUpdated(filteredList) {
      this.filteredList = filteredList
      this.componentKey++
    }
  },
  watch: {
    async currentUser() {
      this.setPurchaseOrdersFormattedList(null)
      await this.updateImpersonationData()
      await this.getAllNamesForFilter()
      this.clearPOFilters()
    },
    isNamesFilterLoading(val) {
      if(val) {
        this.clearPOFilters()
      }
    }
  },
  created() {
    if(Object.keys(this.poTableUserPreferences).length === 0) {
      this.resetPoTableUserPreferences()
    }
    //This check is to ensure call to getPurchaseOrders in all the cases except when (isAPAdmin===true && viewingAPUserDataFor===true)
    //The above case only happens when currentUSer is an Admin and is viewing Invoices/PO for other users using Admin Toggle Button.
    if ((!this.isAPAdmin || !this.viewingAPUserDataFor)){
      this.getPurchaseOrders();
    }
  },
  mounted() {
    //Calling this method here to ensure that we have refs available for PurchaseOrders when we switch tabs.
    this.updateTotalValueWithSortedData()
  }

}
</script>


<style scoped>
.totals-container {
  height: 50px;
}
</style>

<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>